import React, { FC } from 'react';
import mainCss from './styles/side-navigation.scss';
import css from './styles/side-navigation-link.scss';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsSideNavigationCollapsed } from '../../redux/actions/appActions';

interface Props {
  to: string;
  onClick: () => void;
  isSelected: boolean;
  imgSrc: string;
  title: string;
}

export const SideNavigationLink: FC<Props> = ({ to, onClick, isSelected, imgSrc, title }) => {
  const { t } = useTranslation();
  const isCollapsed = useSelector(getIsSideNavigationCollapsed);

  return (
    <NavLink to={to} onClick={onClick}>
      <div className={classNames(css.iconContainer, isSelected && css.selected, isCollapsed && css.collapsed)}>
        <img src={imgSrc} className={mainCss.icon} />
        {!isCollapsed && <div className={mainCss.title}>{t(title)}</div>}
      </div>
    </NavLink>
  );
};
